
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import ChaletIcon from '@mui/icons-material/Chalet';
import GroupIcon from '@mui/icons-material/Group';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import StarIcon from '@mui/icons-material/Star';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import AirlineSeatReclineExtraIcon from '@mui/icons-material/AirlineSeatReclineExtra';
import PolicyIcon from '@mui/icons-material/Policy';
import TtkList from './TtkList';
 

const VenueTTK = ({ data }) => {
    const checkNAStatus = (num) => {
        const numberString = num?.toString();
        return numberString?.length <= 2 ? " NA" : (
            <span>&nbsp;&#8377;&nbsp; {num}</span>
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className='row mb-1'>
                    <div className='col-md-3'>
                        <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since:</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                    </div>
                    <div className='col-md-3'>
                        <p ><DirectionsCarFilledIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Cars can park at Venue :</b>&nbsp;<span>{data?.parkingSize}</span></p>
                    </div>
                    <div className='col-md-3'>
                        <p><PolicyIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Alcohol Policy :</b>&nbsp;<TtkList data={data?.alcoholPolicy} /></p>
                    </div>
                    <div className='col-md-3'>
                        <p><PolicyIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>DJ Policy :</b>&nbsp;<TtkList data={data?.djPolicy} /></p>
                    </div>
                </div>

                <div className='row mb-1'>
                    <div className='col-md-3'>
                        <p> <ChaletIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Total No. of Rooms :</b>&nbsp;<span>{data?.roomCount}</span></p>
                    </div>
                    <div className='col-md-3'>
                        <p> <ChaletIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Average Room Price :</b>&nbsp;&#8377;&nbsp;<span>{data?.avgRoomPrice}</span></p>
                    </div>
                    {/* <div className='col-md-3'>
                <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Price :</b>&nbsp;<span> {data?.startingPrice}</span></p>
            </div> */}
                    <div className='col-md-3'>
                        <p> <GroupIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Max Capacity :</b>&nbsp;<span>{data?.venueCapacity} </span></p>
                    </div>
                    <div className='col-md-3'>
                        <p><StarIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Star Rating  : </b>&nbsp;<span>{data?.starRating}</span></p>
                    </div>
                </div>

                <div className='row mb-1'>

                    {/* <div className='col-md-3'>
                     <p><DirectionsCarFilledIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Parking:</b>&nbsp;<TtkList data={data?.parking} /></p>
                     </div> */}

                    <div className='col-md-3'>
                        <p><AirlineSeatReclineExtraIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Space :</b>&nbsp;<TtkList data={data?.space} /></p>
                    </div>
                    <div className='col-md-3'>
                        <p><CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Small Party Venue :</b>&nbsp;<TtkList data={data?.smallPartiesVenue} /></p>
                    </div>
                    <div className='col-md-3'>
                        <p> <PolicyIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Catering Policy :</b>&nbsp;<TtkList data={data?.catering} /></p>
                    </div>
                    <div className='col-md-3'>
                        <p><PolicyIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Decor Policy :</b>&nbsp;<TtkList data={data?.decorPolicy} /></p>
                    </div>
                </div>
                <div className='row mb-1'>
                    <div className='col-md-3'>
                        <p> &nbsp;<b>Starting Veg Price Per Plate :</b><span>{checkNAStatus(data?.vegPrice)} + GST</span></p>
                    </div>
                    {
                        (data?.nonVegPrice > 100) && (
                            <div className='col-md-3'>
                                <p> &nbsp;<b>Starting Non Veg Price Per Plate :</b><span>{checkNAStatus(data?.nonVegPrice)} + GST</span></p>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default VenueTTK
